<div class="flex items-center gap-2">
  @if (isLoading()) {
    <div class="flex gap-[3px]">
      @for (i of 24 | avsTimes; track $index) {
        <div class="bar bar--skeleton"></div>
      }
    </div>
  } @else {
    <div class="flex gap-[3px]">
      @for (bar of hourBars(); track bar.hour) {
        <div
          class="bar"
          (click)="onBarClick(bar)"
          [style.background-color]="bar.backgroundColor"
          [tp]="barTooltip"
          [tpData]="bar"
          [tpDelay]="300"
          tpPlacement="top"
          tpTrigger="mouseenter"
          tpVariation="popper"
        ></div>
      }
    </div>
  }
</div>

<ng-template
  #barTooltip
  let-bar="data"
>
  <div class="csw-tooltip">
    <div class="csw-tooltip__header">
      <span class="csw-tooltip__time">{{ bar.timeLabel }}</span>
      <span class="csw-tooltip__sep">·</span>
      <span class="csw-tooltip__date">{{ bar.dateLabel }}</span>
    </div>
    <span
      class="csw-tooltip__status"
      [style.color]="bar.stateColor"
    >{{ bar.stateLabel }}</span>
  </div>
</ng-template>
